import React from 'react';

const Überschrift = () => {
  // 1. Die Liste der Texte
  const headerTexts = [
  "Willkommen zurück – lasst uns die nächsten Abenteuer planen!",
  "Herzlich willkommen: Gemeinsam zu neuen Horizonten!",
  "Zurück an Bord – eure Reiseplanung wartet!",
  "Schön, dass ihr da seid: Lasst uns Welten entdecken!",
  "Herzlichst: Zeit für gemeinsame Traumreisen!",
  "Zurück und bereit – plant mit uns!",
  "Es freut uns, euch wiederzubegrüßen: Abenteuer voraus!",
  "Willkommen zurück zu euren Lieblingszielen!",
  "Gemeinsam weiterreisen – willkommen!",
  "Zurück im Rhythmus der Entdeckungen!",
  "Willkommen: Lasst die Planung beginnen!",
  "Herzlich zurück – eure Weltkarte erweitert sich!",
  "Schön, euch zurückzuhaben: Neue Routen warten!",
  "Zurück zu unvergesslichen Plänen!",
  "Es ist eine Freude: Gemeinsame Reisen gestalten!",
  "Willkommen zurück – lasst uns die Welt erobern!",
  "Herzlich willkommen: Eure Abenteuer fortsetzen!",
  "Zurück und inspiriert – plant mit Leidenschaft!",
  "Willkommen zurück – lasst uns die Welt neu kartieren!",
  "Herzlich willkommen: Gemeinsame Entdeckungen erneuern!",
  "Zurück im Abenteuer-Modus – plant mit uns!",
  "Schön, euch wiederzusehen: Neue Ziele im Visier!",
  "Willkommen zurück zu euren Wanderträumen!",
  "Herzlichst: Zeit für kollektive Reiserouten!",
  "Zurück und verbunden – lasst die Planung fließen!",
  "Es freut uns: Abenteuer, die wir gemeinsam meistern!",
  "Gemeinsam erkunden – herzlich willkommen!",
  "Zurück im Fluss der Inspirationen!",
  "Willkommen: Die nächste Etappe wartet!",
  "Herzlich zurück – erweitert eure Horizonte!",
  "Schön, euch da zu haben: Routen der Zukunft schmieden!",
  "Willkommen im Kreis der Entdecker!",
  "Zurück zu euren epischen Plänen!",
  "Es ist uns eine Ehre: Reisen als Team gestalten!",
  "Willkommen zurück – erobert neue Pfade!",
  "Herzlich willkommen: Fortsetzung der Reiseepos!",
  "Zurück und voller Energie – lasst uns planen!"
];

  // 2. Funktion zur Auswahl eines zufälligen Index
  const randomIndex = Math.floor(Math.random() * headerTexts.length);

  // 3. Auswahl des zufälligen Textes
  const randomText = headerTexts[randomIndex];

  return (
    <div>
      {/* 4. Anzeige des zufälligen Textes im h1-Element */}
      <h1>{randomText}</h1>
    </div>
  );
};

export default Überschrift;